<template>
  <div class="baseLayout">
    <ApolloQuery :query="query ? query : {}"
                 :variables="variables"
                 :skip="skip"
    >
      <template slot-scope="{ result: { error, data, loading }, isLoading }">
        <slot name="title-reco" v-if="data" :data="data"></slot>
        <div class="u-bg--white u-align--left top">
          <slot name="title" v-if="data" :data="data"></slot>
          <div v-if="isLoading"><loading/></div>
        </div>

        <row class="u-bg--grey">
          <div class="col-lg-8">
            <slot name="profile-section"></slot>
            <slot name="main-section-reco"  v-if="data" :data="data"></slot>
            <slot name="main-section" v-if="data" :data="data"></slot>
            <slot name="learn-about" v-if="data" :data="data"></slot>

            <div v-if="isLoading"><loading/></div>
            <div v-if="error"><error/></div>
          </div>

          <aside class="col-lg-4">
            <slot name="card-section" :data="data" v-if="data"></slot>
            <div class="loading" v-if="isLoading"><loading/></div>
            <div v-if="error"><error/></div>
          </aside>

          <slot name="modal-section" :data="data" v-if="data"></slot>
        </row>
      </template>

    </ApolloQuery>
  </div>
</template>

<script>
  import Row from "./Row";
  import LearnMore from "../LearnMore/LearnMore";
  import Loading from "../Core/Loading";
  import Error from "../Core/Error";


  export default {
    name: 'BaseLayout',
    props: ['query', 'variables', 'titleText', 'skip'],
    components: {Error, Loading, LearnMore, Row},
    data: () => {
      return {
        results: false
      }
    },
  }
</script>

<style lang="scss">
  .baseLayout {
    padding-left: 0;
    padding-right: 0;
    margin-left: auto;
    margin-right: auto;
    max-width: 1440px;

    .card-study {
      margin-bottom: rem(30px);
    }

    @include mq($until: MD) {
      .col-lg-8 {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
</style>
